import ui from './reducer';
import * as uiActions from './actions';

export {
  uiActions
}

export default ui;
